import Form from './DividerForm'
import isEmpty from './DividerIsEmpty'
import Section from './DividerSection'
import Thumbnail from './DividerThumbnail'

export default { Form, isEmpty, Section, Thumbnail }
